<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="ユーザID、名前、ふりがな、メイン所属、職種、役職、補足情報から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="careworkerFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="careworkers"
      :router="router"
      @import="importModal"
      @remove="remove"
      @exportFile="exportFile"
    >
    </controller>
    <div class="modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/careworkers/add',
      showloadingModal: false,
      showImportModal: false,
      records: [],
      csvData: [],
      confirmed: ''
    }
  },
  computed: {
    careworkers() {
      return this.$store.state.careworkers.careworkers
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedCareworkerList() {
      return this.$store.state.careworkers.selectedCareworkerList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      var selectedCareworkerList = this.selectedCareworkerList.map(
        carewoker => {
          let userId = carewoker.userId
          return {userId}
        }
      )
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'careworkers/deleteCareworkers',
          selectedCareworkerList
        )
        this.$store.dispatch('careworkers/clearSelectedCareworkerList')
        this.finishWord = '対象のユーザを削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/careworkers') {
          this.$router.push('/careworkers')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0050') {
            this.finishWord =
              this.errorMsg.MSGCRC0050.name +
              this.errorMsg.MSGCRC0050.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0050'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0050.name +
            this.errorMsg.MSGCRC0050.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    careworkerFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(e) {
      this.records = e
      this.showImportModal = true
    },
    async importFile(e) {
      e = this.records
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      for (let i = 0; i < e.length; i++) {
        let obj = {}
        let header = this.$store.state.error.exportTitle.careworkerTitle.replace(
          '\r\n',
          ''
        )
        let data = e[i].replace('\r', '')
        if (data !== header) {
          this.csvSplit(data)
          var csvArrayList = this.csvData
          this.csvData = []
          if (
            csvArrayList.length !==
            this.$store.state.error.importErrorNumber.importUserNumber
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_230007
            let eventType = 9
            let reason = 'MSGCRC0008'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0008.name +
              this.errorMsg.MSGCRC0008.beforeValue +
              (i + 1) +
              this.errorMsg.MSGCRC0008.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          obj['userId'] = csvArrayList[0]
          obj['familyName'] = csvArrayList[1]
          obj['name'] = csvArrayList[2]
          obj['pronunciation'] = csvArrayList[3]
          obj['postId'] = csvArrayList[4]
          obj['postCode'] = csvArrayList[5]
          obj['postName'] = csvArrayList[6]
          obj['sub1PostId'] = csvArrayList[7]
          obj['sub1PostCode'] = csvArrayList[8]
          obj['sub1PostName'] = csvArrayList[9]
          obj['sub2PostId'] = csvArrayList[10]
          obj['sub2PostCode'] = csvArrayList[11]
          obj['sub2PostName'] = csvArrayList[12]
          obj['sub3PostId'] = csvArrayList[13]
          obj['sub3PostCode'] = csvArrayList[14]
          obj['sub3PostName'] = csvArrayList[15]
          obj['sub4PostId'] = csvArrayList[16]
          obj['sub4PostCode'] = csvArrayList[17]
          obj['sub4PostName'] = csvArrayList[18]
          obj['job'] = csvArrayList[19]
          obj['position'] = csvArrayList[20]
          const replaceBirthday = csvArrayList[21]
          let pattern = /[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12][0-9]|3[01])/
          if (
            !replaceBirthday.match(pattern) ||
            !this.isValidDate(replaceBirthday)
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_230009
            let eventType = 9
            let reason = 'MSGCRC0183'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0183.name +
              (i + 1) +
              '行目：' +
              this.errorMsg.MSGCRC0183.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          // Timezone設定で変更すると 設定できない日付が発生するため固定で埋め込む
          obj['birthday'] = `${replaceBirthday.replaceAll(
            '/',
            '-'
          )}T00:00:00.000Z`
          const finalData = csvArrayList[22].replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return ''
            } else {
              return ''
            }
          })
          obj['memo'] = finalData.replaceAll('\\n', '\n')
          obj['fileRowCount'] = String(i + 1)
          createList.push(obj)
        }
      }
      if (location.pathname !== '/careworkers') {
        this.$router.push('../careworkers')
      }
      try {
        await this.$store.dispatch('careworkers/importUsers', createList)
        this.$emit('list-reload')
        this.finishWord = 'インポートしました。'
        this.showFinishModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230009
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message.split(',')
            if (errorMessage[0] === 'MSGCRC0041') {
              this.finishWord =
                this.errorMsg.MSGCRC0041.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0041.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0042') {
              this.finishWord =
                this.errorMsg.MSGCRC0042.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0042.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0043') {
              this.finishWord =
                this.errorMsg.MSGCRC0043.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0043.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0044') {
              this.finishWord =
                this.errorMsg.MSGCRC0044.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0044.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0093') {
              this.finishWord =
                this.errorMsg.MSGCRC0093.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0093.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0102') {
              this.finishWord =
                this.errorMsg.MSGCRC0102.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0102.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0103') {
              this.finishWord =
                this.errorMsg.MSGCRC0103.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0103.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0104') {
              this.finishWord =
                this.errorMsg.MSGCRC0104.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0104.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0105') {
              this.finishWord =
                this.errorMsg.MSGCRC0105.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0105.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0106') {
              this.finishWord =
                this.errorMsg.MSGCRC0106.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0106.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0107') {
              this.finishWord =
                this.errorMsg.MSGCRC0107.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0107.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0108') {
              this.finishWord =
                this.errorMsg.MSGCRC0108.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0108.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0118') {
              this.finishWord =
                this.errorMsg.MSGCRC0118.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0118.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0123') {
              this.finishWord =
                this.errorMsg.MSGCRC0123.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0123.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0131') {
              this.finishWord =
                this.errorMsg.MSGCRC0131.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0131.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0132') {
              this.finishWord =
                this.errorMsg.MSGCRC0132.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0132.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0137') {
              this.finishWord =
                this.errorMsg.MSGCRC0137.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0137.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0148') {
              this.finishWord =
                this.errorMsg.MSGCRC0148.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0148.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0149') {
              this.finishWord =
                this.errorMsg.MSGCRC0149.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0149.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0156') {
              this.finishWord =
                this.errorMsg.MSGCRC0156.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0156.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0157') {
              this.finishWord =
                this.errorMsg.MSGCRC0157.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0157.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0158') {
              this.finishWord =
                this.errorMsg.MSGCRC0158.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0158.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0159') {
              this.finishWord =
                this.errorMsg.MSGCRC0159.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0159.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0160') {
              this.finishWord =
                this.errorMsg.MSGCRC0160.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0160.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0180') {
              this.finishWord =
                this.errorMsg.MSGCRC0180.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0180.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0181') {
              this.finishWord =
                this.errorMsg.MSGCRC0181.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0181.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0182') {
              this.finishWord =
                this.errorMsg.MSGCRC0182.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0182.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0183') {
              this.finishWord =
                this.errorMsg.MSGCRC0183.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0183.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0185') {
              this.finishWord =
                this.errorMsg.MSGCRC0185.name +
                (Number(errorMessage[1]) + 1) +
                this.errorMsg.MSGCRC0185.beforeValue +
                errorMessage[1] +
                this.errorMsg.MSGCRC0185.afterValue +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0186') {
              this.finishWord =
                this.errorMsg.MSGCRC0186.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0186.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0273') {
              this.finishWord =
                this.errorMsg.MSGCRC0273.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0273.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0264') {
              this.finishWord =
                this.errorMsg.MSGCRC0264.name +
                this.errorMsg.MSGCRC0264.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.finishWord =
                this.errorMsg.MSGCRC0054.name +
                this.errorMsg.MSGCRC0054.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage[0] + ' '
            reason += error.response.status
          } else {
            var obj = error.response.data
            var stringName = Object.keys(obj)[0]
            if (stringName.endsWith('birthday')) {
              this.finishWord =
                this.errorMsg.MSGCRC0144.name +
                this.errorMsg.MSGCRC0144.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0144'
            } else {
              this.finishWord =
                this.errorMsg.MSGCRC0054.name +
                this.errorMsg.MSGCRC0054.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0054'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    csvSplit(line) {
      let c = ''
      let s = ''
      let before = ''
      let singleQuoteFlg = false
      let escapeFlg = false
      for (let i = 0; i < line.length; i++) {
        before = c
        c = line.charAt(i)
        if (c === ',' && !singleQuoteFlg) {
          this.csvData.push(s)
          s = ''
        } else if (c === ',' && singleQuoteFlg) {
          s = s + c
        } else if (c === '"') {
          if (before === '"' && escapeFlg) {
            s = s + c
            escapeFlg = false
          } else {
            if (i !== line.lengt - 1) {
              // 最終文字ではない場合
              if (line.charAt(i + 1) === '"' && singleQuoteFlg) {
                escapeFlg = true
              } else {
                singleQuoteFlg = !singleQuoteFlg
              }
            } else {
              singleQuoteFlg = !singleQuoteFlg
            }
          }
        } else {
          s = s + c
        }
      }
      if (line.charAt(line.length - 1) === ',') {
        // csvファイルの行の最終文字が , の場合
        this.csvData.push('')
      } else {
        this.csvData.push(s)
      }
    },
    async exportFile(jobList) {
      let exportJobList = jobList.map(job => {
        return {job: job.job}
      })
      var selectedCareworkerIdList = this.selectedCareworkerList.map(user => {
        return {userId: user.userId}
      })
      this.showloadingModal = true
      try {
        let result = this.$store.state.error.exportTitle.careworkerTitle
        const params = {
          userList: selectedCareworkerIdList,
          jobList: exportJobList
        }
        if (selectedCareworkerIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('careworkers/setExportData', params)

        const exportList = this.$store.state.careworkers.exportData
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          let dateBirthday = new Date(exportList[i].birthday)
          let strBirthday =
            dateBirthday.getFullYear() +
            '/' +
            ('0' + (dateBirthday.getMonth() + 1)).substr(-2) +
            '/' +
            ('0' + dateBirthday.getDate()).substr(-2)

          result +=
            exportList[i].userId +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].familyName) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].name) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].pronunciation) +
            ',' +
            exportList[i].postId +
            ',' +
            exportList[i].postCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].postName) +
            ',' +
            exportList[i].sub1PostId +
            ',' +
            exportList[i].sub1PostCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].sub1PostName) +
            ',' +
            exportList[i].sub2PostId +
            ',' +
            exportList[i].sub2PostCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].sub2PostName) +
            ',' +
            exportList[i].sub3PostId +
            ',' +
            exportList[i].sub3PostCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].sub3PostName) +
            ',' +
            exportList[i].sub4PostId +
            ',' +
            exportList[i].sub4PostCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].sub4PostName) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].job) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].position) +
            ',' +
            strBirthday +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].memo) +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, 'ケアワーカー一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ケアワーカー一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ケアワーカー一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_230005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0055 '
          this.finishWord =
            this.errorMsg.MSGCRC0055.name +
            this.errorMsg.MSGCRC0055.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        }
        // 改行がある場合、文字列「￥n」に変換する
        else if (c === '\n') {
          s = s + '\\n'
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    },
    isValidDate(dateString) {
      const [year, month, day] = dateString.split('/').map(Number)
      const date = new Date(year, month - 1, day)
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      )
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/controlbar.vue